export enum TrackingEvent {
  GroupSelected = `[Groups] Data group selected`,
}

export enum TrackingEventPropertyName {
  CurrentDataGroupId = `Current data_group_id`,
  CurrentDataGroupName = `Current data group_name`,
  NewDataGroupId = `New data_group_id`,
  NewDataGroupName = `New data group_name`,
}
